@if (filter === 'by-time') {
    <accordion
        class="top-accordion"
        [isExpanded]="isExpanded"
        [card]="true"
        data-crlat="outerAccordion"
        (function)="toggleByMeetingAccordion(0, 'Events')">
        <left-side>
            <span class="left-title-text" [i18n]="'sb.events'" data-crlat="headerTitle.leftMessage"></span>
        </left-side>
        <accordion-body>
            @for (event of orderedEvents; track trackById($index, event)) {
                <list-card
                    data-crlat="race.antepost.event"
                    [item]="event"
                    [title]="event.localTime + ' ' + event.name"
                    [link]="event.link"
                    [date]="event.date"
                    [attr.data-eventid]="event.id"
                    data-crlat="racing.futureEvent"
                    [eventId]="event.id"
                    [isEventOverlay]="isEventOverlay"
                    [filter]="filter"
                    (overlayContent)="overlayContentHandler($event, event)">
                    <promotion-icon [mode]="'sm'" [type]="'event'" [display]="event.drilldownTagNames" data-crlat="promotionIcons"> </promotion-icon>
                </list-card>
            }
        </accordion-body>
    </accordion>
}
@if (filter === 'by-meeting' && loadAccordion) {
    @for (classesTypeName of filteredTypeNames; track trackById(index, classesTypeName); let index = $index) {
        <accordion
            class="top-accordion"
            [accordionTitle]="classesTypeName.name"
            [card]="true"
            data-crlat="outerAccordion"
            [isExpanded]="classesTypeName.isExpanded"
            (function)="toggleByMeetingAccordion(index, classesTypeName.name)">
            <accordion-body>
                @for (event of orderedEventsByTypeNames[index]; track trackById($index, event)) {
                    <list-card
                        data-crlat="race.antepost.event"
                        [item]="event"
                        [title]="event.localTime + ' ' + event.name"
                        [link]="event.link"
                        [date]="event.date"
                        [attr.data-eventid]="event.id"
                        [eventId]="event.id"
                        data-crlat="racing.futureEvent"
                        [isEventOverlay]="isEventOverlay"
                        [filter]="filter"
                        (overlayContent)="overlayContentHandler($event, event)">
                        <promotion-icon
                            [mode]="'sm'"
                            [type]="'event'"
                            [display]="event.drilldownTagNames"
                            data-crlat="promotionIcons"></promotion-icon>
                    </list-card>
                }
            </accordion-body>
        </accordion>
    }
}
